import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  clearPostLoginRedirect,
  getPostLoginRedirect,
  isInvitationRedirect,
} from '@/utils/postLoginRedirect';

export function PostLoginRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;

    const redirect = getPostLoginRedirect();
    if (!redirect || !isInvitationRedirect(redirect)) return;

    const redirectPath = redirect.split('?')[0];
    if (location.pathname === redirectPath) return;

    hasRedirected.current = true;
    navigate(redirect, { replace: true });
    clearPostLoginRedirect();
  }, [location.pathname, navigate]);

  return null;
}
